import { Routes } from '@angular/router';


export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./home/home.component').then(m => m.HomeComponent)
  },
  {
    path: 'discover',
    loadComponent: () => import('./search/search.component').then(m => m.SearchComponent)
  },
  {
    path: 'search',
    redirectTo: 'discover',
    pathMatch: 'full'
  },
  {
    path: 'preview/:slug/:id',
    loadComponent: () => import('./preview/preview.component').then(m => m.PreviewComponent)
  },
  {
    path: 'event/:slug/:id',
    loadComponent: () => import('./event-detail/event-detail.component').then(m => m.EventDetailComponent)
  },
  {
    path: 'event/:slug/:id/booking',
    loadComponent: () => import('./booking/booking.component').then(m => m.BookingComponent)
  },
  {
    path: 'event/:slug/:id/booking/tickets',
    loadComponent: () => import('./tickets/tickets.component').then(m => m.TicketsComponent)
  },
  {
    path: 'event/:slug/:id/booking/seating',
    loadComponent: () => import('./seating/seating.component').then(m => m.SeatingComponent)
  },
  {
    path: 'event/:slug/:id/review',
    loadComponent: () => import('./review/review.component').then(m => m.ReviewComponent)
  },
  {
    path: 'event/:id/review',
    loadComponent: () => import('./review/review.component').then(m => m.ReviewComponent)
  },
  {
    path: 'event/:id/booking/seating',
    loadComponent: () => import('./seating/seating.component').then(m => m.SeatingComponent)
  },
  {
    path: 'event/:id/booking/tickets',
    loadComponent: () => import('./tickets/tickets.component').then(m => m.TicketsComponent)
  },
  {
    path: 'event/:id/booking',
    loadComponent: () => import('./booking/booking.component').then(m => m.BookingComponent)
  },
  {
    path: 'event/:id',
    loadComponent: () => import('./event-detail/event-detail.component').then(m => m.EventDetailComponent)
  },
  {
    path: 'checkout',
    loadComponent: () => import('./checkout/checkout.component').then(m => m.CheckoutComponent)
  },
  {
    path: 'success',
    loadComponent: () => import('./checkout/checkout.component').then(m => m.CheckoutComponent)
  },
  {
    path: 'payment-failed',
    loadComponent: () => import('./payment-failed/payment-failed.component').then(m => m.PaymentFailedComponent)
  },
  {
    path: 'cart',
    loadComponent: () => import('./my-cart/my-cart.component').then(m => m.MyCartComponent)
  },
  {
    path: 'orders',
    loadComponent: () => import('./order/order.component').then(m => m.OrderComponent)
  },
  {
    path: 'profile',
    loadComponent: () => import('./profile/profile.component').then(m => m.ProfileComponent)
  },
  {
    path: 'terms',
    loadComponent: () => import(`./terms-conditions/terms-conditions.component`).then(m => m.TermsConditionsComponent)
  },

  {
    path: 'privacy',
    loadComponent: () => import('./privacy-policy/privacy-policy.component').then(m => m.PrivacyPolicyComponent)
  },
  {
    path: 'refund-policy',
    loadComponent: () => import('./refund-policy/refund-policy.component').then(m => m.RefundPolicyComponent)
  },
  {
    path: 'organizer-faq',
    loadComponent: () => import('./organizer-faq/organizer-faq.component').then(m => m.OrganizerFaqComponent)
  },
  {
    path: 'about-us',
    loadComponent: () => import('./about-us/about-us.component').then(m => m.AboutUsComponent)
  },
  {
    path: 'coming-soon',
    loadComponent: () => import('./comming-soon/comming-soon.component').then(m => m.CommingSoonComponent)
  },
  {
    path: 'help-center',
    loadComponent: () => import('./help-center/help-center.component').then(m => m.HelpCenterComponent)
  },

  {
    path: 'contact-and-support',
    loadComponent: () => import('./contact-and-support/contact-and-support.component').then(m => m.ContactAndSupportComponent)
  },
  {
    path: 'track-ticket',
    loadComponent: () => import('./track-ticket/track-ticket.component').then(m => m.TrackTicketComponent)
  },

  {
    path: '**',
    redirectTo: '',
  }
];
